import { faker } from "@faker-js/faker";
import { Axios } from "axios";

/**
 * exposes an interface for interaction with user endpoints
 */
class UserInterface {
  client: Axios;

  /**
   * constructor to set Axios client
   * @param client Axios client
   */
  constructor(client: Axios) {
    this.client = client;
    this.client.interceptors.request.use((config) => {
      config.params = config.params || {};
      return config;
    });
  }

  /**
   * Get all users. Currently, mock because no api exists.
   * @param params
   */
  getAll(params?: { [key: string]: string | number | boolean }): any {
    if (!params?.featuredCreators) {
      throw new Error("Only possible for featured creators");
    }
    const names = Array.from({ length: 5 }, () => ({
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
    }));

    const getRandomCollections = () => {
      const rand = Math.floor(Math.random() * (14 - 3 + 1)) + 3;
      return Array.from({ length: rand }, () =>
        faker.image.abstract(450, 300, true)
      );
    };

    return names.map(({ firstName, lastName }) => ({
      name: firstName + " " + lastName,
      username: faker.internet.userName(firstName, lastName),
      avatar: faker.internet.avatar(),
      collections: getRandomCollections(),
    }));
  }
}

export default UserInterface;
